import { connect } from 'react-redux';
import moment from 'moment';

import { DIAGNOSTICS_CHARGER_TASK_TYPE } from '../../constants/chargerTask';

import View from './component';

export const DEFAULT_STATE = {
  simple: true,
  type: DIAGNOSTICS_CHARGER_TASK_TYPE,
  collectFromTimestamp: moment().utc().subtract(1, 'days'),
  collectToTimestamp: moment().utc(),
  diagnostics: [],
  autoUploadSizeLimit: 20,
  autoUpload: true,
  note: '',
  enableNotifications: true,
  systemInfo: true,
  pcapFiles: true,
  configs: true,
};

export const toSaving = (formData, additionalProps = {}) => ({
  ...formData,
  collectFromTimestamp: moment(formData.collectFromTimestamp).format('X'),
  collectToTimestamp: moment(formData.collectToTimestamp).format('X'),
  ...additionalProps,
});

export const toEditing = (apiData, additionalProps = {}) => ({
  ...apiData,
  collectFromTimestamp: moment(apiData.collectFromTimestamp, 'X'),
  collectToTimestamp: moment(apiData.collectToTimestamp, 'X'),
  ...additionalProps,
});

export const validate = (formData) => {
  const from = formData.collectFromTimestamp.format('X');
  const to = formData.collectToTimestamp.format('X');

  if (to < from) {
    return 'The start logs time has to be early than the end logs time';
  }

  if (!formData.simple && formData.autoUpload && formData.autoUploadSizeLimit <= 0) {
    return 'Max upload file size can\'t be less or equal to zero';
  }

  return '';
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(View);
